export default "__VITE_ASSET__4759f462__"